import axios from 'axios';
import pathToRegexp from 'path-to-regexp';
import queryString from 'query-string';
import config from '../config';
import handlRequestError from '../utils/handleRequestError';
import helpers from './helpers';

export default function request(requestConfig) {
  const urlParams = requestConfig.urlParams || {};
  const filters = Object.assign({}, urlParams.filter);
  const endpoint = requestConfig.endpoint || config.api.endpoint;
  Object.keys(urlParams).forEach((key) => {
    urlParams[key] = String(urlParams[key]);
  });

  const url = endpoint + pathToRegexp.compile(requestConfig.url)(urlParams);
  const paramsSerializer = (toSerialize) => {
    return queryString.stringify(toSerialize, { arrayFormat: 'bracket' });
  };

  return axios({ ...requestConfig, url, params: filters, paramsSerializer }).then((response) => {
    const { statusText, status, headers, data } = response;
    const responseData = headers['content-type'] && headers['content-type'].includes('application/json') ?
      data :
      { data };

    return Promise.resolve({
      headers,
      success: true,
      message: statusText,
      statusCode: status,
      ...responseData,
      // original data, please use it when you need data. do no use direct `...responseData` due to key collision
      body: data,
    });
  }).catch((error) => {
    const { response } = error;
    let is2FAError = false;
    let msg;
    let statusCode;
    let errors = {};
    if (response && response instanceof Object) {
      const { data, statusText } = response;
      statusCode = response.status;
      msg = data.message || statusText;
      errors = data.errors;
      is2FAError = !!data.is2FA;
    } else {
      statusCode = 600;
      msg = error.message || 'Network Error';
    }
    if (axios.isCancel(error)) {
      msg = 'request canceled';
      statusCode = 499;
    }

    if (statusCode === 403) {
      helpers.forceLogout();
    }

    if (statusCode === 422 && response.data.code === 'IN_USE') {
      handlRequestError(msg, errors);
    }

    return Promise.reject({
      success: false,
      statusCode,
      message: msg,
      errors,
      code: response ? response.data.code : undefined,
      is2FAError,
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js